import React, { Component } from "react";
import { withRouter } from "react-router";
import { Phone, Mail, Calendar, ArrowRight, User } from "react-feather";
import EmptyState from "../common/EmptyState";

// Customers as "Hello, I'm…" name tags. Shows a page of cards at a time
// with a "Show more" button, so long lists stay quick.
const PAGE = 48;
const TONES = ["sky", "butter", "peach", "mint", "lilac"];

export const formatJoinDate = (createdAt) => {
  if (!createdAt) return "—";
  const secs = createdAt.seconds || createdAt._seconds;
  if (!secs) return "—";
  return new Date(secs * 1000).toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
};

// Some records hold the literal string "undefined" as the customer ID.
export const validId = (id) =>
  id !== undefined && id !== null && id !== "" && String(id) !== "undefined";

// A letter avatar only makes sense for names that start with a letter
// (many accounts use their phone number as the name).
export const avatarLetter = (name) => {
  const c = String(name || "").trim().charAt(0);
  return /[A-Za-z\u0980-\u09FF]/.test(c) ? c.toUpperCase() : null;
};

// Same name → same colour, so a customer keeps their tag colour.
export const toneFor = (name) => {
  const s = String(name || "?");
  let h = 0;
  for (let i = 0; i < s.length; i++) h = (h * 31 + s.charCodeAt(i)) >>> 0;
  return TONES[h % TONES.length];
};

export class Datatable extends Component {
  constructor(props) {
    super(props);
    this.state = { shown: PAGE };
  }

  componentDidUpdate(prevProps) {
    // A new search (resetKey = the search text) starts from the first page.
    if (prevProps.resetKey !== this.props.resetKey && this.state.shown !== PAGE) {
      this.setState({ shown: PAGE });
    }
  }

  open = (user) => {
    this.props.history.push(`${process.env.PUBLIC_URL}/users/list-user/${user.uid}`);
  };

  render() {
    const { myData, emptyText } = this.props;
    const users = myData || [];
    const visible = users.slice(0, this.state.shown);

    if (users.length === 0) {
      return <EmptyState>{emptyText || "No customers found."}</EmptyState>;
    }

    return (
      <>
        <ul className="kd-members">
          {visible.map((user, i) => {
            const name = user.displayName || "Customer";
            const tone = toneFor(user.displayName || user.uid);
            const mobile = user.mobileNo || user.mobileNumber;
            return (
              <li
                key={user.uid}
                className={`kd-member kd-st--${tone}`}
                style={{ "--i": Math.min(i, 12) }}
              >
                <button
                  type="button"
                  className="kd-member-card"
                  onClick={() => this.open(user)}
                  aria-label={`Open ${name}'s profile`}
                >
                  <span className="kd-member-band">
                    <span className="kd-member-hello">Hello, I'm</span>
                    {validId(user.userId) && <span className="kd-member-id">#{user.userId}</span>}
                  </span>
                  <span className="kd-member-avatar" aria-hidden="true">
                    {user.imageUrl ? (
                      <img src={user.imageUrl} alt="" referrerPolicy="no-referrer" />
                    ) : (
                      avatarLetter(name) || <User size={26} />
                    )}
                  </span>
                  <span className="kd-member-name">{name}</span>
                  <span className="kd-member-lines">
                    {mobile !== name && (
                      <span>
                        <Phone size={12} aria-hidden="true" />
                        {mobile || "No mobile"}
                      </span>
                    )}
                    <span title={user.email || ""}>
                      <Mail size={12} aria-hidden="true" />
                      {user.email || "No email"}
                    </span>
                  </span>
                  <span className="kd-member-foot">
                    <span className="kd-member-joined">
                      <Calendar size={12} aria-hidden="true" />
                      Joined {formatJoinDate(user.createdAt)}
                    </span>
                    <span className="kd-member-go">
                      View <ArrowRight size={12} aria-hidden="true" />
                    </span>
                  </span>
                </button>
              </li>
            );
          })}
        </ul>

        {users.length > visible.length && (
          <div className="kd-members-more">
            <button
              type="button"
              className="btn btn-secondary"
              onClick={() => this.setState({ shown: this.state.shown + PAGE })}
            >
              Show more ({users.length - visible.length} left)
            </button>
          </div>
        )}
      </>
    );
  }
}

export default withRouter(Datatable);
